import { Button, makeStyles, Box } from "@material-ui/core";
import React from "react";
import { Link, useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addToCart } from "../../redux-store/shop/shop";
import { toast } from "react-toastify";
import { FaShoppingBasket } from "react-icons/fa";
import { Skeleton } from "@material-ui/lab";
import Swal from "sweetalert2";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "10px",
    border: `1px solid ${theme.palette.secondary.dark}`,
    textDecoration: "none",
    textAlign: "center",
    transition: "0.2s linear",
    "&:hover": {
      boxShadow: `0px 0px 15px 1px ${theme.palette.secondary.dark}`,
    },
    height:"100%",
    display:"flex",
    flexDirection:"column",
  },
  coverImg: {
    width: "80%",
    height: 250,
    objectFit: "contain",
  },
  imgContainer: {
    width: "90%",
    margin: "0 auto",
  },
  bookContent: {
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    marginTop: "auto",
  },
  bookTitle: {
    fontSize: "20px",
    fontWeight: 700,
    lineHeight: "24px",
    marginBottom: "10px",
    
  },
  price: {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "10px",
  },
  cartBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    fontSize: "12px",
    fontWeight: "600",
    borderRadius: "2px",
    padding: "10px 0",
    width: "110px",
    "&:hover": {
      backgroundColor: theme.palette.secondary.light,
      color: theme.palette.primary.main,
    },
  },
  toastBtn: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
    textDecoration: "none",
    marginLeft: "20px",
  },
  mainPreOrderLabel: {
    display: "flex",
    justifyContent: "center",
  },
  preOrderLabel: {
    marginTop: "3px",
    backgroundColor: "yellow",
    fontSize: "13px",
    fontWeight: "bold",
    padding: "2px 6px",
  },
}));

function BookAdminCard(props) {
  const { title, price, cover, bookId, preOrder } = props;
  const state = useSelector((state) => state.shop);
  const { cart } = state;
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const handleViewBook = () => {
    history.push(`/admin-book/${bookId}`);
  };

  //   const ToastBox = () => {
  //     return (
  //       <div>
  //         CART UPDATED
  //         <Link to="/cart" style={{ textDecoration: "none" }}>
  //           <Button
  //             variant="contained"
  //             className={classes.toastBtn}
  //             endIcon={<FaShoppingBasket />}
  //           >
  //             View Cart
  //           </Button>
  //         </Link>
  //       </div>
  //     );
  //   };

  return (
    <div className={classes.root}>
      {cover && (
        <Link
          to={`/admin-book/${bookId}`}
          style={{ textDecoration: "none", color: "black" }}
        >
          <Box className={classes.imgContainer}>
            <img src={cover} className={classes.coverImg} />
          </Box>
        </Link>
      )}

      <div className={classes.bookContent}>
      <h2 className={classes.bookTitle}>
        {title}
        <div className={classes.mainPreOrderLabel}>
          {preOrder && <span className={classes.preOrderLabel}>Pre-Order</span>}
        </div>
      </h2>
      <h3 className={classes.price}>$ {price}</h3>
      {/* {cart.find((item) => item.bookId===bookId)? <Link to="/cart" style={{textDecoration:'none'}}>View Cart</Link>: */}
      {/* // <Button className={classes.cartBtn} onClick={() => handleAddToCart(bookId, 1)}>ADD TO CART</Button> */}
      {/* <Link style={{ textDecoration: "none" }} to={`/book/${bookId}/checkout`}> */}
      <Button className={classes.cartBtn} onClick={handleViewBook}>
        View Book
      </Button>
      </div>
      {/* </Link> */}
      {/* // } */}
    </div>
  );
}

export default BookAdminCard;
